import FormButton from "components/FormButton";
import PopupComp from "components/PopupComp";
import React from "react";

export const ActionButtons = (props) => {
  const {
    showPopModal,
    setShowPopModal,
    selectedData,
    setSelectedData,
    popupConfig,
    popBtnClick,
    form_buttons,
    handleNext,
    formErr,
    clearFieldError,
    handleLinkWithCrn,
    handleDelinkWithCrn,
    handleTerminate,
    handelAddRecursiveData,
    customClass,
    handleCrEdit
  } = props;

  return (
    <>
      <PopupComp
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        form_elements={popupConfig?.form_elements || []}
        form_buttons={popupConfig?.form_buttons || []}
        modalShow={showPopModal}
        setModalShow={setShowPopModal}
        handleNext={popBtnClick}
        form_Err={formErr}
        clearFieldError={clearFieldError}
        modalSize={popupConfig?.modal_size || "md"}
        handleLinkWithCrn={handleLinkWithCrn}
        handleDelinkWithCrn={handleDelinkWithCrn}
        handleTerminate ={handleTerminate}
        handelAddRecursiveData={handelAddRecursiveData}
        handleCREdit={handleCrEdit}
      />
      {form_buttons && (
        <FormButton
          formButtons={form_buttons}
          handleNext={handleNext}
          selectedData={selectedData}
          className="m-0"
          customClass={customClass}
        />
      )}
    </>
  );
};
